import { render, staticRenderFns } from "./KitBuilderWrapper.vue?vue&type=template&id=4f9b3b0e&scoped=true&"
import script from "./KitBuilderWrapper.vue?vue&type=script&lang=ts&"
export * from "./KitBuilderWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b3b0e",
  null
  
)

export default component.exports